import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { LookupDataServiceService } from 'src/app/services/lookup-data-service.service';
import { NotificationService } from 'src/app/services/notification-service';

@Component({
  selector: 'app-balance-check',
  templateUrl: './balance-check.component.html',
  styleUrls: ['./balance-check.component.scss']
})
export class BalanceCheckComponent implements OnInit {

  balanceCheckForm: FormGroup;
  IsHaveTable: boolean = false;
  customerBalance: any;

  constructor(
    private fb: FormBuilder,
    private lookupDataService: LookupDataServiceService,
    private toastr: NotificationService) { }

  ngOnInit(): void {
    this.initializeValidators();
  }

  initializeValidators() {
    this.balanceCheckForm = this.fb.group({customerAccNo: ['',Validators.required]});
  }

  searchreset() {
    this.IsHaveTable = false;
    this.balanceCheckForm.reset()
  }

  generateCustBalance() {
    if(this.balanceCheckForm.valid){
      this.lookupDataService.getCustomerBillingBalance(this.balanceCheckForm.value.customerAccNo).subscribe(result => {
          this.customerBalance = result;
          if (this.customerBalance == "invalid") {
            this.IsHaveTable = false;
            this.toastr.showError('No Balance for Customer or Customer not exist')
          } else {
            this.IsHaveTable = true;
          }
        })
    }
    else{
        this.toastr.showError("Please fill the details")
    }
  }

}
